import { createFileRoute } from "@tanstack/react-router";
import {
  fleaMarketItemListInfiniteQueryOptions,
  fleaMarketSellerInfoQueryOptions,
} from "~/features/fleamarket/api";
import { FleaMarketSellerTemplate } from "~/features/fleamarket/FleaMarketSellerTemplate";

export const Route = createFileRoute(
  "/_authenticated/fleamarket/seller/$sellerId",
)({
  loader: ({ context: { queryClient }, params: { sellerId } }) =>
    Promise.all([
      queryClient
        .ensureQueryData(fleaMarketSellerInfoQueryOptions(sellerId))
        .catch(() => undefined),
      queryClient
        .ensureInfiniteQueryData(
          fleaMarketItemListInfiniteQueryOptions({ sellerId }),
        )
        .catch(() => undefined),
    ]),
  component: FleaMarketSellerTemplate,
});
